import {
  React,
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import { NavBar } from "../Navbar/NavBar";
import { ClipLoader } from "react-spinners";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { Modal, TextField, Box, Select, InputLabel } from "@material-ui/core";
import "../Settlement Tracker/settlementTracker.css";
import NumberFormatCustom from "../NumberFormatCustom";
import { debounce } from "lodash";
import { FormControl, MenuItem } from "@mui/material";
import Sidebar from "../Sidebar";
function Provisions() {
  const [orders, setOrders] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("user_detail"));
  const [activeTab, setActiveTab] = useState("pendingForCollection");
  const [activeModal, setActiveModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [amount, setAmount] = useState("");
  const [category, setCategory] = useState("");
  const [date, setDate] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [windowStart, setWindowStart] = useState(1);
  const [remark, setRemark] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    debouncedSearch(value);
  };
  const token = localStorage.getItem("token");
  const fetchOrders = async (query = searchQuery) => {
    try {
      const url = "/workflow/api/provisions/order"; // Fixed the URL format
      const params = {
        page,
        limit,
        order_id: query ? query : undefined,
        provision_status: activeTab === "collected",
      };
      if (activeTab === "l1ApprovalPending")
        params.provision_approved_status = "Pending";
      if (activeTab === "l2ApprovalPending")
        params.provision_approved_status = "Pending_l2";

      const headers = {
        Authorization: `Bearer ${token}`,
      };

      const response = await axios.get(url, { params, headers });

      if (response.data.orders && response.data.orders.length > 0) {
        const sortedOrders = response.data.orders.sort(
          (a, b) => parseInt(b.order_id) - parseInt(a.order_id)
        );
        setOrders(sortedOrders);
        setTotalPages(Math.ceil(response.data.count / limit));
      } else {
        setOrders([]);
        setTotalPages(0);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [page, activeTab, searchQuery]);

  useEffect(() => {
    setPage(1);
  }, [searchQuery, activeTab]);

  const debouncedSearch = useCallback(
    debounce((query) => {
      setPage(1);
      fetchOrders(query);
    }, 300),
    [fetchOrders]
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handlePageClick = (pageNumber) => {
    setPage(pageNumber);
    if (pageNumber > windowStart + 4) {
      setWindowStart(windowStart + 1);
    } else if (pageNumber < windowStart) {
      setWindowStart(windowStart - 1);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // January is 0!
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  const handleSubmit = async () => {
    if (!selectedOrder) return;

    if (Number(amount) > Number(selectedOrder.balance_due_amount)) {
      toast.error("Entered amount should not exceed the balance due amount");
      return;
    }

    const selectedDate = new Date(date);
    const currentDate = new Date();

    selectedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);

    if (selectedDate > currentDate) {
      toast.error("You cannot select a future date");
      return;
    }
    try {
      const token = localStorage.getItem("token");
      const headers = {
        Authorization: `Bearer ${token}`,
      };

      if (!category) {
        toast.error("Please select provision category");
        return;
      }

      if (category === "Others" && !remark) {
        toast.error("Please add remark");
      } else {
        const response = await axios.patch(
          `/workflow/api/provisions/order/${selectedOrder.order_id}`,
          {
            provision_status: true,
            provision_date: date,
            provision_amount: amount,
            provision_remark: remark,
            provision_actioner: userDetails?.user_name,
            provision_category: category === "Others" ? remark : category,
          },
          { headers } // Include headers in the axios request
        );

        if (response.data.status) {
          toast.success(response.data.message);
          setActiveModal(false);
          fetchOrders();
          setAmount("");
          setCategory("");
          setDate("");
          setRemark("");
        } else {
          toast.error("Failed to add order to provision.");
        }
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again later.");
    }

    // try {
    //   const token = localStorage.getItem("token");
    //   const headers = {
    //     Authorization: `Bearer ${token}`,
    //   };
    //   if (!category) {
    //     toast.error("Please select provision category");
    //     return
    //   }
    //     if ( category === "Others" && !remark) {
    //       toast.error("Please add remark");
    //     }
    //     else {
    //       const response = await axios.patch(
    //         `/workflow/api/provisions/order/${selectedOrder.order_id}`,
    //         {
    //           provision_status: true,
    //           provision_date: date,
    //           provision_amount: amount,
    //           provision_remark: remark,
    //           provision_actioner: userDetails?.user_name,
    //           provision_category: category === "Others" ? remark : category,
    //         },
    //         { headers } // Include headers in the axios request
    //       );

    //       if (response.data.status) {
    //         toast.success(response.data.message);
    //         setActiveModal(false);
    //         fetchOrders();
    //         setAmount("");
    //         setCategory("");
    //         setDate("");
    //         setRemark("");
    //       } else {
    //         toast.error("Failed to add order to provision.");
    //       }

    //     }
    //   // } else {
    //   //   toast.error("Please select provision category");
    //   // }
    // } catch (error) {
    //   toast.error("Something went wrong. Please try again later.");
    // }
  };

  return (
    <div className=" ">
      <div className="mt-3">
        <ToastContainer />
        {/*------------------------------------------- Lending Partner Starts --------------------------------------- */}

        <div className="text-gray-500 p-2 mt-5">
          <section className="fluid w-full px-2">
            <div className="flex flex-col  ">
              <div className="mb-3">
                <button
                  onClick={() => setActiveTab("pendingForCollection")}
                  role="tab"
                  className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                    activeTab === "pendingForCollection"
                      ? "text-white bg-dark shadow-sm"
                      : "text-gray-500 dark:text-gray-300"
                  } mr-3`}
                >
                  Non Provisioned
                </button>
                <button
                  onClick={() => setActiveTab("collected")}
                  role="tab"
                  className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                    activeTab === "collected"
                      ? "text-white bg-dark shadow-sm"
                      : "text-gray-500 dark:text-gray-300"
                  }`}
                >
                  Provisioned
                </button>
                <button
                  onClick={() => setActiveTab("l1ApprovalPending")}
                  role="tab"
                  className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                    activeTab === "l1ApprovalPending"
                      ? "text-white bg-dark shadow-sm"
                      : "text-gray-500 dark:text-gray-300"
                  }`}
                >
                  L1 Approval Pending
                </button>

                <button
                  onClick={() => setActiveTab("l2ApprovalPending")}
                  role="tab"
                  className={`py-2.5 px-4 rounded-lg duration-150 font-medium  ${
                    activeTab === "l2ApprovalPending"
                      ? "text-white bg-dark shadow-sm"
                      : "text-gray-500 dark:text-gray-300"
                  }`}
                >
                  L2 Approval Pending
                </button>
              </div>
            </div>
            <div className="flex items-right justify-end space-x-5">
              <input
                value={searchQuery}
                onChange={handleSearchChange}
                className="shadow-lg shadow-cyan-500/50 rounded-md w-100 h-10 mt-8 border border-gray-300 py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
                type="text"
                placeholder="Search Order Id"
              />
            </div>
            <div className="flex justify-center mt-4">
              <div className="flex items-center">
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setWindowStart(1);
                    setPage(1);
                  }}
                  className="mx-1 text-sm font-semibold text-white bg-gray-900 px-4 py-2 rounded-md hover:bg-gray-800"
                >
                  First Page
                </a>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageClick(page - 1);
                  }}
                  className={`mx-1 text-sm font-semibold text-white bg-gray-900 px-4 py-2 rounded-md hover:bg-gray-800 ${
                    page === 1 && "opacity-50 cursor-not-allowed"
                  }`}
                  disabled={page === 1}
                >
                  &larr;
                </button>
                {[...Array(Math.min(5, totalPages))].map((_, i) => {
                  const pageNumber = windowStart + i;
                  if (pageNumber > totalPages) return null;
                  return (
                    <a
                      key={i}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        handlePageClick(pageNumber);
                      }}
                      className={`mx-1 flex items-center rounded-md border border-gray-400 px-3 py-1 ${
                        pageNumber === page
                          ? "text-gray-900 bg-gray-200"
                          : "text-gray-900 hover:scale-105"
                      }`}
                    >
                      {pageNumber}
                    </a>
                  );
                })}
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    handlePageClick(page + 1);
                  }}
                  className={`mx-1 text-sm font-semibold text-white bg-gray-900 px-4 py-2 rounded-md hover:bg-gray-800 ${
                    page === totalPages && "opacity-50 cursor-not-allowed"
                  }`}
                  disabled={page === totalPages}
                >
                  &rarr;
                </button>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setWindowStart(totalPages - 4);
                  }}
                  className={`mx-1 text-sm font-semibold text-white bg-gray-900 px-4 py-2 rounded-md hover:bg-gray-800 ${
                    totalPages <= 5 && "opacity-50 cursor-not-allowed"
                  }`}
                >
                  Last Page
                </a>
              </div>
            </div>
            <div className="flex flex-col mt-2">
              <div className="overflow-x-auto bg-cyan-500 shadow-lg shadow-cyan-500/50">
                <div className="inline-block min-w-full py-2 align-middle bg-cyan-500 shadow-lg shadow-cyan-500/50">
                  <div className="overflow-hidden border border-gray-200 dark:border-gray-700 md:rounded-lg bg-cyan-500 shadow-lg shadow-cyan-500/50">
                    <div className="flex flex-col mt-2">
                      <div className="overflow-x-auto">
                        <div className="inline-block min-w-full py-2 align-middle">
                          <div className="overflow-hidden  md:rounded-lg">
                            {orders.length === 0 ? (
                              <div className="text-2xl">No Records Found</div>
                            ) : (
                              <table className="min-w-full">
                                <thead className="bg-gray-50">
                                  <tr>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Order ID
                                    </th>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Buyer Name
                                    </th>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Provision Category
                                    </th>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Total CP
                                    </th>
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Total SP
                                    </th>
                                    {activeTab === "pendingForCollection" && (
                                      <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                        Balance Due Amount
                                      </th>
                                    )}
                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      Repayment Last Date
                                    </th>

                                    <th className="py-3 px-4 text-lg font-normal text-center text-white bg-gray-900">
                                      {activeTab === "pendingForCollection"
                                        ? "Settle Amount"
                                        : "Provision Amount"}
                                    </th>
                                  </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                  {orders.map((order) => (
                                    <tr key={order.order_id}>
                                      <td className="py-3 px-4 text-center">
                                        {order.order_id}
                                      </td>
                                      <td className="py-3 px-4 text-center">
                                        {order.buyer_name}
                                      </td>
                                      <td className="py-3 px-4 text-center">
                                        {order.provision_category}
                                      </td>

                                      <td className="py-3 px-4 text-center">
                                        {order.total_cp}
                                      </td>
                                      <td className="py-3 px-4 text-center">
                                        {order.total_sp}
                                      </td>

                                      {activeTab === "pendingForCollection" && (
                                        <td className="py-3 px-4 text-center">
                                          <span className="inline-flex items-center text-xl font-semibold justify-center bg-red-500 text-white w-full h-full rounded-full">
                                            ₹{" "}
                                            {parseFloat(
                                              order.balance_due_amount
                                            ).toLocaleString("en-IN")}
                                          </span>
                                        </td>
                                      )}
                                      <td className="py-3 px-4 text-center">
                                        {formatDate(order.repayment_last_date)}
                                      </td>
                                      <td className="py-3 px-4 text-center">
                                        {activeTab ===
                                        "pendingForCollection" ? (
                                          <button
                                            onClick={() => {
                                              console.log(
                                                "Balance Due Amount: ",
                                                order.balance_due_amount
                                              );
                                              setSelectedOrder(order);
                                              setAmount(
                                                Number(
                                                  order.balance_due_amount
                                                ).toFixed(2)
                                              );
                                              setActiveModal(true);
                                            }}
                                            className="px-2 py-1 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                                          >
                                            View
                                          </button>
                                        ) : (
                                          <span className="inline-flex items-center text-xl font-semibold justify-center bg-green-500 text-white w-full h-full rounded-full">
                                            ₹{" "}
                                            {order.provision_amount
                                              ? parseFloat(
                                                  order.provision_amount
                                                ).toLocaleString("en-IN")
                                              : "0.00"}
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <Modal
          open={activeModal}
          onClose={() => {
            setActiveModal(false);
            setSelectedOrder(null);
            setAmount("");
            setCategory();
            setDate("");
            setRemark("");
          }}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              width: 400,
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              borderRadius: 24,
              p: 4,
            }}
          >
            <div className="flex flex-col items-center justify-center space-y-5">
              <h2 className="text-2xl font-normal text-center mb-4">
                Are you sure you want to submit
              </h2>
              <TextField
                className="shadow-md rounded-md w-full"
                label="Amount"
                variant="outlined"
                type="text"
                value={amount.toString()}
                onChange={(e) => setAmount(e.target.value)}
              />
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Provision Category
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  onChange={(e) => setCategory(e.target.value)}
                  value={category}
                >
                  <MenuItem value="Provision">Provision</MenuItem>
                  <MenuItem value="Converted to Equity">
                    Converted to Equity
                  </MenuItem>
                  <MenuItem value="Others">Others</MenuItem>
                  <MenuItem value="Write off">Write off</MenuItem>
                </Select>
              </FormControl>
              <TextField
                className="shadow-md rounded-md w-full"
                label="Remark"
                variant="outlined"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />

              <TextField
                className="shadow-md rounded-md w-full"
                label="Date"
                type="date"
                variant="outlined"
                value={date}
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(e) => setDate(e.target.value)}
              />

              <button
                type="button"
                onClick={handleSubmit}
                className="w-full rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
              >
                Submit
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </div>
  );
}

export default Provisions;
